import React, { useEffect, useState } from "react";

import { useRouter } from "next/router";

import { ProductData } from "data/product/products";
import { Button } from "studio-design-system";

import {
  PRODUCT_PAGE_ADD_TO_CART_SELECTED,
  PRODUCT_PAGE_ADD_TO_CART_MODAL_VIEWED,
} from "~/analytics/Amplitude/amplitudeConstants";
import { addUTMPropertiesToEvent } from "~/analytics/Amplitude/amplitudeUtils";
import { useAnalytics } from "~/analytics/useAnalytics";
import { useCart } from "~/hooks/cart/useCart";

import * as styles from "./AddToCartButton.css";

export const AddToCartButton = ({
  product,
  handleAddToCartShowModal,
  disabled,
  variant,
  className,
}: {
  product: ProductData;
  handleAddToCartShowModal: () => void;
  disabled: boolean;
  variant?: "primary" | "secondary";
  className?: string;
}): React.ReactElement => {
  const router = useRouter();
  const { cartItems, addToCart, getCartPathWithQuery } = useCart();
  const { trackAmplitudeEvent } = useAnalytics();
  const [alreadyInCart, setAlreadyInCart] = useState(false);

  useEffect(() => {
    setAlreadyInCart(cartItems.filter((prod) => prod.id === product.id).length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, cartItems]);

  const onAddToCart = () => {
    trackAmplitudeEvent(PRODUCT_PAGE_ADD_TO_CART_SELECTED, {
      ...addUTMPropertiesToEvent(),
    });
    if (!alreadyInCart) {
      addToCart(product);
      handleAddToCartShowModal();
      trackAmplitudeEvent(PRODUCT_PAGE_ADD_TO_CART_MODAL_VIEWED, {
        ...addUTMPropertiesToEvent(),
      });
    } else {
      router.push(getCartPathWithQuery());
    }
  };

  return (
    <Button
      onClick={onAddToCart}
      className={className ? className : styles.ctaButton}
      disabled={disabled}
      variant={variant}
    >
      {alreadyInCart ? "Go to cart" : "Add to cart"}
    </Button>
  );
};
